// extracted by mini-css-extract-plugin
export default {"wql":"WalletQuickLinksCard_wql__aYojK","wql__links":"WalletQuickLinksCard_wql__links__TI1GI","wql__links_item":"WalletQuickLinksCard_wql__links_item__fJ6xp"};